export default "__VITE_ASSET__BB7wTNG6__"